const ATTRIBUTION_KEY = "ibp_attribution";
const ATTRIBUTION_TTL_MS = 90 * 24 * 60 * 60 * 1000;

const TRACKED_PARAMS = [
  "gclid",
  "gbraid",
  "wbraid",
  "msclkid",
  "fbclid",
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
];

function readStoredAttribution() {
  if (typeof localStorage === "undefined") return {};
  try {
    const payload = JSON.parse(localStorage.getItem(ATTRIBUTION_KEY) || "null");
    if (!payload || !payload.params || !payload.saved_at) return {};
    if (Date.now() - payload.saved_at > ATTRIBUTION_TTL_MS) {
      localStorage.removeItem(ATTRIBUTION_KEY);
      return {};
    }
    return payload.params;
  } catch (e) {
    return {};
  }
}

function writeStoredAttribution(params) {
  if (typeof localStorage === "undefined" || !Object.keys(params).length) return;
  try {
    localStorage.setItem(
      ATTRIBUTION_KEY,
      JSON.stringify({ params, saved_at: Date.now() })
    );
  } catch (e) {
    // Attribution is helpful, not critical; never block the buying path.
  }
}

export function captureAttribution() {
  if (typeof window === "undefined") return {};
  const current = new URLSearchParams(window.location.search);
  const next = { ...readStoredAttribution() };

  TRACKED_PARAMS.forEach((key) => {
    const value = current.get(key);
    if (value) next[key] = value;
  });

  if (document.referrer && !next.referrer) {
    try {
      const ref = new URL(document.referrer);
      if (ref.hostname !== window.location.hostname) next.referrer = document.referrer;
    } catch (e) {
      // Ignore malformed referrers.
    }
  }

  writeStoredAttribution(next);
  return next;
}

export function getAttribution() {
  return readStoredAttribution();
}

export function decorateCheckoutUrl(rawUrl, checkoutContext = {}) {
  if (!rawUrl || typeof window === "undefined") return rawUrl;
  const params = getAttribution();

  try {
    const url = new URL(rawUrl, window.location.origin);
    Object.entries(params).forEach(([key, value]) => {
      if (value && !url.searchParams.has(key)) url.searchParams.set(key, value);
    });
    if (checkoutContext.email && !url.searchParams.has("checkout[email]")) {
      url.searchParams.set("checkout[email]", checkoutContext.email);
    }
    if (checkoutContext.accountId) {
      url.searchParams.set("attributes[IBP Account ID]", checkoutContext.accountId);
      url.searchParams.set("attributes[IBP Account Email]", checkoutContext.email || "");
    }
    return url.toString();
  } catch (e) {
    return rawUrl;
  }
}
